function debounce(func, wait = 20, immediate = true) {
	var timeout;
	return function() {
		var context = this, args = arguments;
		var later = function() {
			timeout = null;
			if (!immediate) func.apply(context, args);
		};
		var callNow = immediate && !timeout;
		clearTimeout(timeout);
		timeout = setTimeout(later, wait);
		if (callNow) func.apply(context, args);
	};
}

const navBtnAnimScroll = () => {
	function scrollToTrigger() {
		let pageY = window.pageYOffset || document.documentElement.scrollTop;
		const triggerElemPos = $(".white-trigger-js").position();

		if (!triggerElemPos) {
			return;
		}

		if (pageY > triggerElemPos.top) {
			$(".toggle-menu-main").addClass("toggle-menu-main--white");
		}
		if (pageY < triggerElemPos.top) {
			$(".toggle-menu-main").removeClass("toggle-menu-main--white");
		}
	}
	window.addEventListener("scroll", debounce(scrollToTrigger, 12));
};

export default navBtnAnimScroll



// WEBPACK FOOTER //
// ./scripts/modules/navBtnAnimationScroll.js